import React, { useEffect, useRef } from 'react'
import { useAb } from 'hooks'
import { constants } from 'helpers'
import { useHistory } from 'router'
import links from 'links'

import { useProductsInQueueContext } from 'containers/ProductsInQueueProvider/ProductsInQueueProvider'

import { ProductListProps } from 'compositions/landings/BestsellersBlock/components/ProductList/ProductList'

import { HomePageViewProps } from 'pages/landing/View/View'


import ProductsFeedSection from '../ProductsFeedSection/ProductsFeedSection'
import BestsellersSection from '../BestsellersSection/BestsellersSection'


export type ProductsSectionProps = {
  className?: string
  customProducts?: HomePageViewProps['customProductsBlock']
  fetchMoreButtonTitle?: ProductListProps['fetchMoreButtonTitle']
  fetchMoreButtonStyle?: ProductListProps['fetchMoreButtonStyle']
}

const ProductsSection: React.FunctionComponent<ProductsSectionProps> = (props) => {
  const { className, customProducts, fetchMoreButtonTitle, fetchMoreButtonStyle } = props

  const { updateCount } = useProductsInQueueContext()
  const history = useHistory()
  const timeoutRef = useRef<NodeJS.Timeout>()

  const isQueueWidgetEnabled = useAb(constants.abTests.homeQueueWidget) === 'b'
  const isAddToQueueRedirectEnabled = useAb(constants.abTests.homeAddToQueueRedirect) === 'b'

  const baseButtonProps = {
    withNotification: false,
    withNonAuthRedirect: false,
    withErrorModals: false,
    withQueueLeadModal: isQueueWidgetEnabled,
    force: true, // to add lep products to queue for users with subscription.hasNeverSubscribed
    metadata: {
      placement: 'Bestsellers',
    },
  }

  const handleBestsellersAddToQueueClick = () => {
    updateCount()
    // Let user see that the product was added to queue before redirect
    if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        history.push(links.subscribe)
      }, 1000)
    }
  }

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current)
  }, [])

  if (customProducts?.slugs) {
    return (
      <ProductsFeedSection
        className={className}
        title={customProducts.title}
        slugs={customProducts.slugs}
        withoutLink={customProducts.withoutLink}
        withRetailPrice={customProducts.withRetailPrice}
        excludeLabels={customProducts.excludeLabels}
        buttonProps={{
          ...baseButtonProps,
          onClick: updateCount,
        }}
      />
    )
  }

  return (
    <BestsellersSection
      className={className}
      title={customProducts?.title}
      buttonProps={{
        ...baseButtonProps,
        onClick: isAddToQueueRedirectEnabled ? handleBestsellersAddToQueueClick : updateCount,
      }}
      fetchMoreButtonTitle={fetchMoreButtonTitle}
      fetchMoreButtonStyle={fetchMoreButtonStyle}
    />
  )
}


export default React.memo(ProductsSection)
